import { DatabaseType } from '../types/database'

export const detectDatabaseType = (fileName: string): DatabaseType => {
  const extension = fileName.toLowerCase().split('.').pop() || ''
  
  switch (extension) {
    case 'db':
    case 'sqlite':
    case 'sqlite3':
      return 'sqlite'
    case 'csv':
      return 'csv'
    case 'tsv':
      return 'tsv'
    case 'json':
      return 'json'
    case 'mdb':
    case 'accdb':
      return 'access'
    case 'sql':
    case 'dump':
    case 'backup':
      return 'postgresql'
    default:
      return 'json' // デフォルト
  }
}

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes'
  
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}

export const readFileAsArrayBuffer = (file: File): Promise<ArrayBuffer> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result as ArrayBuffer)
    reader.onerror = reject
    reader.readAsArrayBuffer(file)
  })
}

export const readFileAsText = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = reject
    reader.readAsText(file)
  })
}

export const downloadFile = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
} 